<template>
  <!-- エラーを表示させるには Form コンポーネント内で利用して rules を設定すること -->
  <Field
    v-slot="{ field, errors }"
    v-model="inputValue"
    :rules="rules"
    :name="name"
    :bails="false"
  >
    <select
      :id="id"
      v-bind="field"
      :name="name"
      :class="[
        inputFormClass,
        $attrs.class,
        errors.length !== 0 ? 'field_with_errors' : '',
        showErrorMessages && errors.length !== 0 ? 'mb-8' : ''
      ]"
      :autocomplete="autocomplete"
      @input="$emit('input', $event)"
      @change="$emit('change', $event)"
    >
      <slot />
    </select>
    <ErrorMessages v-if="showErrorMessages" :errors="errors" />
  </Field>
</template>

<script setup>
import { computed } from 'vue'
import { Field } from 'vee-validate'
import ErrorMessages from '~/src/js/customer/components/atoms/form/ErrorMessages.vue'

defineOptions({
  inheritAttrs: false
})

const props = defineProps({
  modelValue: {
    type: [String, Number],
    required: false,
    default: ''
  },
  value: {
    type: [String, Number],
    required: false,
    default: ''
  },
  id: {
    type: String,
    required: false,
    default: ''
  },
  name: {
    type: String,
    required: false,
    default: ''
  },
  autocomplete: {
    type: String,
    required: false,
    default: ''
  },
  rules: {
    type: String,
    required: false,
    default: ''
  },
  showErrorMessages: {
    type: Boolean,
    required: false,
    default: true
  }
})

const inputValue = computed(() => props.value || props.modelValue)
const selected = computed(() => !!inputValue.value)
const inputFormClass = computed(() => ({
  'select-form': true,
  'select-form--selected': selected.value,
  'select-form--unselected': !selected.value
}))
</script>

<style lang="scss" scoped>
.select-form {
  width: 100%;
  font-size: 1.6rem;
  background: $gray-3;
  border: 1px solid $gray-3;
  border-radius: 8px;
  padding: 1.2rem;
  box-sizing: border-box;
  line-height: 1.6;

  &--selected {
    @extend .select-form;
    @include bg-settings(
      '../../../../../images/icons/chevron-down.svg',
      $white,
      20px,
      20px
    );
    background-position: right 5% top 50%;
    color: $black;
    border: 1px solid $gray-2;
  }

  &--unselected {
    @extend .select-form;
    @include bg-settings(
      '../../../../../images/icons/chevron-down.svg',
      $gray-3,
      20px,
      20px
    );
    background-position: right 5% top 50%;
    color: $gray-1;
  }
}

.field_with_errors {
  border: 1px solid $danger;
  box-sizing: border-box;
}
</style>
